import "./card-template.scss";
import { bindable, bindingMode } from "aurelia-framework";

export class CardTemplate {
    @bindable({ defaultBindingMode: bindingMode.toView })
    public borderClass: string = "";
}
